module.exports = __webpack_public_path__ + "static/media/rm_woodworks.ac913d19.jpg";